<!--<div *ngIf="!isStudent">
  <mat-checkbox (change)="refreshMeetings()" [(ngModel)]="remote">{{'Module_Parts_Remote' | translate}}</mat-checkbox>
</div>-->

<!-- Mandatory parts -->
<mat-accordion displayMode="flat" multi="true">
  <mat-expansion-panel class="accordion-panel" hideToggle expanded="true">
    <mat-expansion-panel-header class="accordion-header">
      <mat-panel-title class="accordion-title">
        <h3>{{'Module_Parts_Mandatory' | translate}}</h3>
      </mat-panel-title>
      <mat-icon svgIcon="expand_more" class="expand"></mat-icon>
    </mat-expansion-panel-header>
    <div class="accordion-content-row">
      <!--No mandatory parts-->
      <div *ngIf="!mandatoryPartsExist()" fxLayout="row" >
        {{'Module_Details_None' | translate}}
      </div>
      <!--Meetingseries-->
      <div *ngFor="let meetingSerie of meetingSeriesMandatory; let i=index">
        <div class="part" fxLayout="row">
          <div fxFlex>{{'Part' | translate}} {{i+1}}</div>
        </div>
        <div fxLayout="row">
          <div fxFlex="17px" class="bullet">-</div>
          <div fxFlex>{{ meetingSerie.title }}</div>
        </div>
        <!--Meetings-->
        <div *ngFor="let meeting of meetingSerie.meetings">
          <div fxLayout="row">
            <div fxFlex="34px" class="bullet">-</div>
            <div fxFlex>{{'Meeting' | translate}}, {{ meeting.title }}</div>
          </div>
        </div>
      </div>
      <!--Assignments and Exams-->
      <!--You have to pass for all-->
      <div *ngIf="minimalOptionsToPass == 0 && parts">
        <div *ngFor="let part of parts; let i=index">
          <div fxLayout="column">
            <div class="part">
              <div fxFlex>{{'Part' | translate}} {{numberOfMeetingParts + i + 1}}</div>
              <div *ngIf="part.weight > 0" fxFlex="100px"><mat-icon svgIcon="weighing" class="weighing-icon"></mat-icon> {{ part.weight }}x</div>
            </div>
            <div *ngIf="isExam(part)">
              <div fxLayout="row">
                <div fxFlex="17px" class="bullet">-</div>
                <div fxFlex>{{'Exam' | translate}}, {{ part.lineItemTitle }} ({{'Code' | translate}}: {{ part.lineItemLabel }})</div>
              </div>
            </div>
          </div>
          <div *ngFor="let sub of part.subModuleLineItems">
            <div fxLayout="row">
              <div fxFlex="17px" class="bullet">-</div>
              <div fxFlex>
                {{ sub.lineItemTitle }} ({{'Code' | translate}}: {{ sub.lineItemLabel }})
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--You have to pass at least for x option group(s) In that case there is 1 part for all exams and exercises-->
      <div *ngIf="minimalOptionsToPass > 0 && parts.length>0">
        <div fxLayout="column">
          <div class="part">
            <div fxFlex>{{'Part' | translate}} {{numberOfMeetingParts + 1}}</div>
            <div *ngIf="parts[0].weight > 0" class="weighing" fxFlex="100px"><mat-icon svgIcon="weighing" class="weighing-icon"></mat-icon> {{ parts[0].weight }}x</div>
          </div>
        </div>
        <div class="options">
          <div fxLayout="row">
            <div fxFlex>{{optionsText}}</div>
          </div>
          <div *ngFor="let part of parts; let i=index">
            <div fxLayout="column">
              <div class="option">
                <div fxFlex>{{'Option' | translate}} {{i+1}}</div>
              </div>
              <div *ngIf="isExam(part)">
                <div fxLayout="row">
                  <div fxFlex="17px" class="bullet">-</div>
                  <div fxFlex>{{'Exam' | translate}}, {{ part.lineItemTitle }} ({{'Code' | translate}}: {{ part.lineItemLabel }})</div>
                </div>
              </div>
            </div>
            <div *ngFor="let sub of part.subModuleLineItems">
              <div fxLayout="row">
                <div fxFlex="17px" class="bullet">-</div>
                <div fxFlex>{{ sub.lineItemTitle }} ({{'Code' | translate}}: {{ sub.lineItemLabel }})</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>

<!-- Extra parts -->
<mat-accordion displayMode="flat" multi="true">
  <mat-expansion-panel class="accordion-panel" hideToggle expanded="true">
    <mat-expansion-panel-header class="accordion-header">
      <mat-panel-title class="accordion-title">
        <h3>{{'Module_Parts_Extra' | translate}}</h3>
      </mat-panel-title>
      <mat-icon svgIcon="expand_more" class="expand"></mat-icon>
    </mat-expansion-panel-header>
    <div class="accordion-content-row">
      <!--No extra parts-->
      <div *ngIf="!extraPartsExist()" fxLayout="row">
        {{'Module_Details_None' | translate}}
      </div>
      <!--Meetingseries-->
      <div *ngFor="let meetingSerie of meetingSeriesExtra; let i=index">
        <div class="part" fxLayout="row">
          <div fxFlex>{{'Part' | translate}} {{i+1}}</div>
        </div>
        <div fxLayout="row">
          <div fxFlex="17px" class="bullet">-</div>
          <div fxFlex>{{ meetingSerie.title }}</div>
        </div>
        <!--Meetings-->
        <div *ngFor="let meeting of meetingSerie.meetings">
          <div fxLayout="row">
            <div fxFlex="34px" class="bullet">-</div>
            <div fxFlex>{{'Meeting' | translate}}, {{ meeting.title }}</div>
          </div>
        </div>
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>
